module.exports = __webpack_public_path__ + "images/02.b6a0cd3a4099229bb22ae3f28f378ba1.png";